import { render, staticRenderFns } from "./SpecialProcurementType.vue?vue&type=template&id=0dde2942"
import script from "./SpecialProcurementType.vue?vue&type=script&lang=js"
export * from "./SpecialProcurementType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports